import { AiOutlineMenu } from "react-icons/ai";
import Button from "../Button/Button";
import { brand, brandLogos } from "../../brand";
import { ImCross } from "react-icons/im";
import "./NavBar.scss";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { marketingUrl } from "../../lib/marketingUrls";

const NavBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isMobileNav = () => window.innerWidth <= 850;

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Close mobile menu when route changes
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  // Close mobile menu when resizing to desktop width
  useEffect(() => {
    const handleResize = () => {
      if (!isMobileNav() && mobileMenuOpen) {
        closeMobileMenu();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileMenuOpen]);

  const menuOpenButtonClicked = () => {
    setMobileMenuOpen(true);
  };

  const menuCloseButtonClicked = () => {
    closeMobileMenu();
  };

  const handleTopLevelNavClick = () => {
    if (mobileMenuOpen) {
      closeMobileMenu();
    }
  };

  return (
    <div id="NavBar">
      <nav>
        <div className="navbar">
          <button
            type="button"
            className="bx bx-menu mobile-menu-toggle"
            onClick={menuOpenButtonClicked}
            aria-label="Open menu"
            aria-expanded={mobileMenuOpen}
          >
            <AiOutlineMenu height={"20px"} />
          </button>
          {mobileMenuOpen && (
            <button
              type="button"
              className="mobile-menu-backdrop"
              aria-label="Close menu"
              onClick={menuCloseButtonClicked}
            />
          )}
          <div className="logo">
            <a href={marketingUrl("/")}>
              <img src={brandLogos.color} alt={brand.displayName} className="navbar-logo" />
            </a>
          </div>
          <div className={`nav-links${mobileMenuOpen ? " mobile-open" : ""}`}>
            <div className="sidebar-logo">
              <img src={brandLogos.white} alt={brand.displayName} className="logo-name" />
              <button
                type="button"
                className="mobile-menu-close"
                onClick={menuCloseButtonClicked}
                aria-label="Close menu"
              >
                <ImCross className="bx bx-x" color="white" />
              </button>
            </div>
            <ul className="links">
              <li className="nav-top-level-item hideInDesktopView">
                <Link to={"/sign-up"} onClick={handleTopLevelNavClick}>
                  Sign Up
                </Link>
              </li>
              <li className="nav-top-level-item hideInDesktopView nav-top-level-item--button">
                <div className="Button">
                  <Link to="/login" onClick={handleTopLevelNavClick}>
                    Login
                  </Link>
                </div>
              </li>
            </ul>
          </div>
          <ul className="search-box">
            <li>
              <Link to={"/sign-up"}>Sign Up</Link>
            </li>
            <Button text="Login" linkTo="/login" />
          </ul>
        </div>
      </nav>
      <div className="navbar-document-offset" aria-hidden="true" />
    </div>
  );
};

export default NavBar;
